import React, { Fragment } from "react";
import img1 from "../../assets/images/logo/Company-Logo/prophecis.webp";
import img2 from "../../assets/images/logo/Company-Logo/nirwana_new.webp";
import img3 from "../../assets/images/logo/Company-Logo/ItsForYou.svg";
import img4 from "../../assets/images/logo/Company-Logo/trioca.webp";

const BrandLogo = [
  {
    img: img1,
    dataDelay: "",
  },
  {
    img: img2,
    dataDelay: "100",
  },
  {
    img: img3,
    dataDelay: "200",
  },
  {
    img: img4,
    dataDelay: "300",
  },
];

const BrandSix = () => {
  return (
    <Fragment>
      <ul className="style-none text-center">
        {BrandLogo.map((item, i) => (
          <li
            key={i}
            className="partner-logo-block-one d-inline-block"
            data-aos="fade-up"
            data-aos-delay={item.dataDelay}
          >
            <a
              href="#"
              className="d-flex align-items-center justify-content-center"
            >
              <img src={item.img} alt="clients" width={100} height={55} />
            </a>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default BrandSix;
